import React, { Component } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,InputAdornment,
  Typography,
  Box,FormControl,Select,MenuItem
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import TablePagination from '@mui/material/TablePagination';
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';
import searchIcon from './images/SEARCH.png';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axiosInstance from "./axiosConfig";

class ServiceManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ServiceData: [],searchText: '', 
	  searchType: "",     
  searchServicetype: "", 
      totalItems: 0,
      page: 0,
      rowsPerPage: 5,
      confirmDialogVisible: false,
      deletingservice: null,
	   itemsPerPageOptions: [5, 10, 25, 50],
    };
  }

  componentDidMount() {
	   document.title = "Prep for Sale- Staff Management";
		if(localStorage.getItem("DCuserid")==null)
		  {
		   this.setState({
            logredirect: true,
			pagename:'/'
          })
		  }
    this.fetchServices();
  }

fetchServices = () => {
  const { page, rowsPerPage, searchText,searchType, searchServicetype } = this.state;

  const params = {
    page,
    limit: rowsPerPage,
    ...(searchText && { search: searchText }), 
	...(searchType !== "" && {searchtype: parseInt(searchType, 10)}),
    ...(searchServicetype !== "" && {searchservicetype: parseInt(searchServicetype, 10)})
  };

  axiosInstance.get(`${Serverurl}servicemanagement/servicemanagementgetall`, { params })
    .then((res) => {
      const { data, totalItems } = res.data;
      this.setState({ ServiceData: data, totalItems });
    })
    .catch(err => console.error('Error fetching services:', err));
};

  onPageChange = (newPage) => {
    this.setState({ page: newPage }, this.fetchServices);
  };

openConfirmDeleteDialog = (id) => {
  const userid = localStorage.getItem("DCuserid");

  confirmAlert({
    title: 'Confirm Delete',
    message: 'Are you sure you want to delete this service?',
    buttons: [
      {
        label: 'Yes',
        onClick: () => {
          axiosInstance
            .delete(`${Serverurl}servicemanagement/servicemanagementdelete/${id}?userid=${userid}`)
            .then(() => this.fetchServices());
        }
      },
      { label: 'No' }
    ]
  });
};

  render() {
    if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 

    return (
       <div className="maincontentDiv">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
 <Typography className="contentHeading" variant="h5" gutterBottom>Services</Typography>
 {/*<NavLink to="/AddService" style={{ textDecoration: 'none' }}>
  <Button 		  style={{
    marginRight: '20px',
    marginTop: '15px'
}}
size="small" variant="contained" className="frmPrimarybtn" startIcon={<AddIcon />}>Add</Button>
 </NavLink>*/}
</Box>
<Box
  sx={{
    display: "flex",
    gap: 2,
    mb: 3,
    flexWrap: "wrap",
    alignItems: "center"
  }}
>
  <Box className="contentSearch" sx={{ display: "flex", flexDirection: "column", minWidth: 200 }}>
    <Typography variant="body1">Title</Typography>
    <TextField
      placeholder="Search"
      size="small"
      value={this.state.searchText}
      onChange={e => this.setState({ searchText: e.target.value, page: 0 })}
	  InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <img
            src={searchIcon} 
            alt="Search"           
          />
        </InputAdornment>
      ),
    }}
    />
  </Box>
  <Box sx={{ display: "flex", flexDirection: "column", width: "230px" }}>
  <Typography variant="body1">Type</Typography>

  <FormControl fullWidth size="small">
    <Select
      value={this.state.searchType}
displayEmpty	  
      onChange={(e) => this.setState({ searchType: e.target.value })}
    >
      <MenuItem value="">All</MenuItem>
      <MenuItem value="1">Premium Service</MenuItem>
      <MenuItem value="2">Service</MenuItem>
     
    </Select>
  </FormControl>
</Box>

<Box sx={{ display: "flex", flexDirection: "column", width: "230px"}}>
  <Typography variant="body1">Service Type</Typography>

  <FormControl fullWidth size="small">
    <Select
	displayEmpty
      value={this.state.searchServicetype}
      onChange={(e) => this.setState({ searchServicetype: e.target.value })}
    >
      <MenuItem value="">All</MenuItem>
      <MenuItem value="1">Service Quote</MenuItem>
      <MenuItem value="2">Inspection</MenuItem>
    </Select>
  </FormControl>
</Box>
  <Button 
  size="small"
    variant="contained"
    className="frmPrimarybtn"
    sx={{ marginTop:3 }}  
    onClick={this.fetchServices}
  >
    Search
  </Button>
</Box>
        <TableContainer component={Paper}>
          <Table aria-label="service table">
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>            
                <TableCell>Actions</TableCell>            
              </TableRow>
            </TableHead>

            <TableBody>
 {this.state.ServiceData.map((item) => (
    <TableRow key={item.sm_id}>
      <TableCell component="th" scope="row">
        {item.sm_title}
      </TableCell>
<TableCell align="center">
  <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}>
    <NavLink to={`/AddService?id=${item.sm_id}`} style={{ textDecoration: 'none' }}>
      <Button 
	  size="small"
        variant="contained" 
        className="frmPrimarybtn" 
        endIcon={<EditIcon />}
      >
        Edit
      </Button>
    </NavLink>
    <Button 
	size="small"
      variant="contained" 
      className="frmSecondarybtn" 
      onClick={() => this.openConfirmDeleteDialog(item.sm_id)} 
      endIcon={<DeleteIcon />}
    >
      Delete
    </Button>
  </Box>
</TableCell>
    </TableRow>
  ))}
            </TableBody>
          </Table>
		   <TablePagination
  component="div"
  count={this.state.totalItems}
  page={this.state.page}
  onPageChange={(event, newPage) => this.setState({ page: newPage }, this.fetchServices)}
  rowsPerPage={this.state.rowsPerPage}
  onRowsPerPageChange={(event) => {
    const newRows = parseInt(event.target.value, 10);
    this.setState({ rowsPerPage: newRows, page: 0 }, this.fetchServices);
  }}
  rowsPerPageOptions={this.state.itemsPerPageOptions}
/>
        </TableContainer>
      </div>
    );
  }
}

export default ServiceManagement;
